import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, } from '@angular/router';


import { TokenStorageService } from '../services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class VigilantGuard implements CanActivateChild {

  constructor(
    private tokenStorageService: TokenStorageService,
    private router: Router
  ) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.tokenStorageService.isLogged()) {
      this.router.navigate(['/'])
      return false;
    }
    return true;
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.tokenStorageService.isLogged()) {
      this.router.navigate(['/'])
      return false;
    }
    return true;
  }

}
